import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Document, DocumentCategory } from '@ceres/domain';

@Component({
    selector: 'ceres-document-overview',
    templateUrl: './document-overview.component.html',
    styleUrls: ['./document-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DocumentOverviewComponent {
    @Input() documents: Document[] = [];
    @Input() readonly = false;
    @Input() showArchiveAction = false;
    @Input() showDeleteAction = true;
    @Input() categorySelectable = false;
    @Input() categories: DocumentCategory[] = ['projectScope', 'projectFinances'];
    @Input() title = '';

    @Output() download = new EventEmitter<Document>();
    @Output() archive = new EventEmitter<Document>();
    @Output() delete = new EventEmitter<Document>();
    @Output() categoryChanged = new EventEmitter<{
        id: number;
        category: DocumentCategory;
    }>();

    readonly categoryI18nKeys: Record<DocumentCategory, string> = {
        projectScope: 'project-scope',
        projectFinances: 'project-finances',
        offer: 'offer',
        order: 'order',
        other: 'other',
        documentation: 'documentation'
    };

    get displayedColumns(): string[] {
        if (this.readonly) {
            const columns = ['name', 'createdAt'];

            if (this.categorySelectable) {
                columns.push('category');
            }

            return columns;
        }

        const columns = ['fileName'];

        if (this.categorySelectable) {
            columns.push('category');
        }

        if (this.showArchiveAction) {
            columns.push('archive');
        }

        if (this.showDeleteAction) {
            columns.push('delete');
        }

        return columns;
    }
}
